import React, { useCallback, useEffect, useState } from 'react';
import Title from '../layouts/Title';
import ContactLeft from './ContactLeft';

const Contact = () => {
  // Define state variables for form inputs
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  // Function to reset form inputs
  const resetForm = () => {
    setName('');
    setPhoneNumber('');
    setEmail('');
    setSubject('');
    setMessage('');
  };
  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    resetForm();
  }, []);

  useEffect(() => {
    handleSubmit();
  }, [handleSubmit]);
  return (
    <section
      id="contact"
      className="w-full py-20 border-b-[1px] dark:border-b-gray-600"
    >
      <div className="flex justify-center items-center text-center">
        <Title title="CONTACT" des="Contact With Me" />
      </div>
      <div className="w-full">
        <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
          <ContactLeft />
          <div className="w-full lgl:w-[60%] h-full py-10 bg-gradient-to-r from-[#fdfdfd] to-[#fafafa] dark:from-[#1e2024] dark:to-[#23272b] flex flex-col gap-8 p-4 lgl:p-8 rounded-lg  shadow-shadowOne dark:shadow-[#1c1e22] shadow-gray-200">
            <form className="w-full flex flex-col gap-4 lgl:gap-6 py-2 lgl:py-5"
              action="https://formspree.io/f/xvoyzdye"
              method="POST"
            >
              <div className="w-full flex flex-col lgl:flex-row gap-10">
                <div className="w-full lgl:w-1/2 flex flex-col gap-4">
                  <p className="text-lg font-normal dark:text-gray-400 text-black uppercase tracking-wide">
                    Your name
                  </p>
                  <input
                    placeholder={"Name"}
                    className={`contactInput`}
                    type="text"
                    name="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="w-full lgl:w-1/2 flex flex-col gap-4">
                  <p className="text-lg font-normal dark:text-gray-400 text-black uppercase tracking-wide">
                    Phone Number
                  </p>
                  <input
                    placeholder={"0312-3456789"}
                    className={`contactInput`}
                    type="text"
                    name="phoneNumber"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <p className="text-lg font-normal dark:text-gray-400 text-black uppercase tracking-wide">
                  Email
                </p>
                <input
                  placeholder={"abc@gmail.com"}
                  className={`contactInput`}
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="flex flex-col gap-4">
                <p className="text-lg font-normal dark:text-gray-400 text-black uppercase tracking-wide">
                  Subject
                </p>
                <input
                  placeholder={"subject"}
                  className={`contactInput`}
                  type="text"
                  name="subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
              </div>
              <div className="flex flex-col gap-4">
                <p className="text-lg font-normal dark:text-gray-400 text-black uppercase tracking-wide">
                  Message
                </p>
                <textarea
                  placeholder={"Message"}
                  className={`contactTextArea`}
                  cols="30"
                  rows="5"
                  name="message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
              </div>
              <div className="w-full">
                <button
                  type='submit'
                  className="w-full h-12 dark:bg-[#141518] bg-blue-600 hover:bg-blue-500 rounded-lg text-base font-semibold dark:text-gray-400 text-white tracking-wider uppercase dark:hover:text-white duration-300 hover:border-[1px] dark:hover:border-designColor hover:border-blue-600 border-blue-600 border-transparent"
                >

                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact